import React from 'react';
import styled from 'styled-components/macro';
import ContentLoader from 'components/utility/ContentLoader/ContentLoader';

const StyledContentLoader = styled(ContentLoader)<any>`
  margin-bottom: ${({ theme, marginbottom }): string =>
    marginbottom ? marginbottom : theme.spacing.medium};
`;

const DSPContentLoader: React.FC<{
  isLargeScreen: boolean;
  tabCount?: number;
  marginbottom?: string;
}> = ({ isLargeScreen, tabCount, marginbottom }): any => {
  const width = 190;
  const height = 64;
  const margin = 8;
  const count = tabCount || 3;

  return (
    <StyledContentLoader
      width={isLargeScreen ? width * count + margin * count : width}
      height={height}
      marginbottom={marginbottom}
    >
      {isLargeScreen ? (
        Array.from({ length: count }).map((_, index) => (
          <rect
            key={`dsp-content-loader-rect-${index}`}
            width={width}
            height={height}
            x={index * width + margin * index}
            y="0"
          />
        ))
      ) : (
        <rect width={width * 2} height={height} x="0" y="0" />
      )}
    </StyledContentLoader>
  );
};

export default DSPContentLoader;
